export type { GraphQLSchema } from "graphql";
import { Headers } from "graphql-request/dist/types.dom";
import type { GraphQLSchema } from "graphql";
import type { Unreliable } from "../utils";
import { GraphQLError } from "graphql";
import { hasOwnProperty } from "../utils";

export interface GqlObjConfig {
  endpoint: string;
  schema: GraphQLSchema;
}

export interface GqlObj {
  directives: {
    ignoreUpdate?: boolean;
    silent?: boolean;
    groups?: string[];
  };
  doc: string;
  operationName: string;
  toString: () => string;
  config?: GqlObjConfig;
}

export type Gql = (docStr: TemplateStringsArray, ...keys: unknown[]) => GqlObj;
export type GqlObjectTransform = (gqlKey: GqlObj) => GqlObj;

export const isGqlObject = (p: unknown): p is GqlObj => {
  return (
    hasOwnProperty(p, "directives") &&
    hasOwnProperty(p, "doc") &&
    hasOwnProperty(p, "operationName")
  );
};

export interface GraphQLRequestError {
  message: string;
  locations?: { line: number; column: number }[];
  path?: string[];
  extensions?: Extensions | null;
}

export type FetcherArg<TVars extends Variables | undefined> = {
  query: GqlObj;
  variables?: TVars | undefined;
};

interface FeapiErrorExtensions {
  errorCode?: string | null;
  errorData?: Record<string, unknown> | null;
}

export class FeapiError extends GraphQLError {
  extensions: FeapiErrorExtensions;

  constructor(message: string, extensions: FeapiErrorExtensions = {}) {
    super(
      message,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      extensions
    );

    this.extensions = extensions;
  }
}

export interface GraphqlErrorResponse<TData = unknown> {
  data?: Unreliable<TData>;
  errors?: FeapiError[];
  status?: number;
  headers?: Headers;
}

export type Extensions = Record<string, unknown>;

// Public
// ------

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type Variables = { [key: string]: any } | null | undefined; // copied from "graphql" package
